export const UTILITY_USER_ICON = `<svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 10 10"
                      fill="none"
                      aria-hidden="true"
                      focusable="false"
                    >
                      <path
                        d="M4.99957 1.25C6.38028 1.25 7.49957 2.36929 7.49957 3.75C7.49957 4.58493 7.08842 5.3211 6.45953 5.77515C7.64037 6.04947 8.5121 6.73727 8.70806 8.12622C8.75625 8.46802 8.46974 8.75 8.12457 8.75H1.87457C1.52958 8.74977 1.24291 8.46788 1.29107 8.12622C1.48695 6.73751 2.35914 6.0496 3.53961 5.77515C2.91103 5.32107 2.49957 4.58468 2.49957 3.75C2.49957 2.36943 3.61905 1.25023 4.99957 1.25Z"
                        fill="currentColor"
                      />
                    </svg>`;
